import { ILocalizable } from "infrastructure/localization";

import { ParentFlag } from "../types/ParentFlag.types";

export const mapParentRequest = (parent?: ILocalizable) => {
  let parentValue: ParentFlag | undefined;

  switch (parent && parent.messageId.value) {
    case "paris-common-option-yes": {
      parentValue = ParentFlag.Yes;
      break;
    }
    case "paris-common-option-no": {
      parentValue = ParentFlag.No;
      break;
    }
    default: {
      parentValue = undefined;
      break;
    }
  }

  return parentValue;
};
